
import { Component, Vue } from "vue-property-decorator";
import {
  getOptionName,
  referralTrackingStatusOptions,
  referralTriggerOptions,
} from "./referral-options";

class ReferralTrackingFilter {
  inviterId: number = null;
  invitedUserId: number = null;
  trigger: number = null;
  status: number = null;

  resetToDefault() {
    this.inviterId = null;
    this.invitedUserId = null;
    this.trigger = null;
    this.status = null;
  }

  toFilterRequest() {
    return {
      InviterId: this.inviterId === null || this.inviterId === ("" as any) ? null : Number(this.inviterId),
      InvitedUserId: this.invitedUserId === null || this.invitedUserId === ("" as any) ? null : Number(this.invitedUserId),
      Trigger: this.trigger,
      Status: this.status,
    };
  }
}

@Component
export default class PageReferralTrackingComponent extends Vue {
  filter: ReferralTrackingFilter = new ReferralTrackingFilter();
  triggerOptions = referralTriggerOptions;
  statusOptions = referralTrackingStatusOptions;
  columnNames = [
    "Создано",
    "ID пригласившего",
    "Пригласивший",
    "ID приглашённого",
    "Приглашённый",
    "Статус начисления",
    "ID правила",
    "Дней премиума",
    "Дата начисления",
    "Премиум действует до",
  ];

  getDataFunc = this.$api.ReferralService.getTrackingListAsync.bind(this.$api.ReferralService);

  getStatusName(status: number): string {
    return getOptionName(this.statusOptions, status);
  }

  getUserLabel(name: string, email: string): string {
    return [name, email].filter(Boolean).join("\n") || "-";
  }
}
